import { useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import { NavContext, SiteShell } from './components/SiteShell';
import type { Path } from './components/SiteShell';
import { Home } from './routes/Home';
import { Impressum } from './routes/Impressum';
import { Datenschutz } from './routes/Datenschutz';
import { PrintIndex } from './print/PrintIndex';

/**
 * Mini-Router ohne externe Bibliothek.
 *
 * WARUM: package.json ist eine "fertige Grundlage" und wird hier nicht
 * angefasst - es bindet keinen Router ein, nur react/react-dom und
 * fontsource. Bei drei Routen genuegt die History-API direkt; eine
 * zusaetzliche Abhaengigkeit wäre Abstraktion auf Vorrat und wuerde
 * ausserdem package.json aendern muessen, was ausserhalb der erlaubten
 * Dateien liegt.
 */
function readPath(): string {
  return window.location.pathname;
}

export function App() {
  const [path, setPath] = useState<string>(readPath);

  useEffect(() => {
    const onPopState = () => setPath(readPath());
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  function navigate(to: Path) {
    if (to !== window.location.pathname) {
      window.history.pushState({}, '', to);
      setPath(to);
    }
    window.scrollTo(0, 0);
  }

  /*
   * Die Drucksachen liegen bewusst AUSSERHALB der Seitenhülle: Briefbogen,
   * Visitenkarte und Flyer bringen ihre eigenen Maße und @page-Regeln mit,
   * und ein Seitenkopf über einem A4-Bogen wäre beim Drucken schlicht
   * falsch. Deshalb früher Ausstieg statt eines weiteren `page`-Zweigs.
   */
  if (path === '/drucksachen') {
    return (
      <NavContext.Provider value={{ path, navigate }}>
        <PrintIndex />
      </NavContext.Provider>
    );
  }

  let page: ReactNode;
  if (path === '/impressum') {
    page = <Impressum />;
  } else if (path === '/datenschutz') {
    page = <Datenschutz />;
  } else {
    // Unbekannte Pfade fallen auf die Startseite zurueck, statt eine leere
    // Seite zu zeigen. Eine eigene 404-Seite ist nicht Teil des Auftrags.
    page = <Home />;
  }

  return (
    <NavContext.Provider value={{ path, navigate }}>
      <SiteShell>{page}</SiteShell>
    </NavContext.Provider>
  );
}
